/** The request's title in the reader's language — what it asks, by whom. (D2) */
import { formatList, useTranslation } from '@tonnie/locale';
import { shareRequestTitle, testitTestLabel } from '@tonnie/onboarding';
import type { MyShareRequest } from '@tonnie/sdk';

export function useShareRequestTitle(
  request: Pick<MyShareRequest, 'asks' | 'tests'>,
  company: string
): string {
  const { t } = useTranslation();
  const tests = formatList(
    request.tests.map((test) => testitTestLabel(test, t)),
    t
  );
  return shareRequestTitle(t, request, company, tests);
}
